import type { ExperienceEvent, FailEvent } from '@atlassian/experience-tracker';

import type { Experience } from './index';

export const failExperienceOnSubExperienceFail = (
	subExperienceNameToCheck: string,
	mainExperienceToFail: Experience,
	events: ExperienceEvent[],
	additionalAttributes?: Record<string, unknown>,
): void => {
	const subExperienceFailEvent = events.find(
		(event): event is FailEvent =>
			event.action === 'taskFail' && event.name === subExperienceNameToCheck,
	);
	if (subExperienceFailEvent) {
		mainExperienceToFail.fail({
			error: subExperienceFailEvent.error,
			attributes: { ...additionalAttributes, ...subExperienceFailEvent.attributes },
		});
	}
};
